// None of this app's client-side events are Meta Standard Events - the
// business-critical conversions (Lead/CompleteRegistration/Purchase/etc.)
// are sent server-side via Conversions API from ms-analytics, keyed off
// backend-authoritative events. Sending anything here via "track" instead
// of "trackCustom" either misrepresents a button-press as a completed
// standard action, or double-counts a conversion the backend already sends.
const identify = (userId?: string | undefined) => {
  // @ts-expect-error fbq injected by Facebook Pixel script
  if (window.fbq) window.fbq("trackCustom", "identify", { userId });
};

const track = (eventName: string, properties?: Record<string, any>) => {
  // @ts-expect-error fbq injected by Facebook Pixel script
  if (window.fbq) window.fbq("trackCustom", eventName, properties);
};

export const Facebook = { identify, track };
